/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export interface RecommendationErrorInfo {
  code?: string;
  message: string;
}

export const RECOMMENDATION_NETWORK_ERROR_INFO: RecommendationErrorInfo = {
  code: 'ERR_NETWORK',
  message: 'Network Error',
};

export const isRecommendationNetworkError = (
  errorInfo?: RecommendationErrorInfo,
) => errorInfo?.code === RECOMMENDATION_NETWORK_ERROR_INFO.code;

export const getRecommendationErrorInfo = (
  error: unknown,
): RecommendationErrorInfo => {
  if (error instanceof Error) {
    const errorWithCode = error as Error & { code?: unknown };

    return {
      code:
        typeof errorWithCode.code === 'string' ? errorWithCode.code : undefined,
      message: error.message,
    };
  }

  return { code: undefined, message: 'Unknown error' };
};
